import React from 'react'
import './testimonial.css'
import Me from '../../assets/avatar.jpg'
import Me2 from '../../assets/avatar2.jpg'
import Me3 from '../../assets/avatar3.jpg'
import Me4 from '../../assets/avatar4.jpg'
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar: Me,
    name: 'Richard John',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam consequatur veniam sed sunt, veritatis sit qui. Velit corrupti magnam repellat.'
  },
  {
    avatar: Me2,
    name: 'Zain malik',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam consequatur veniam sed sunt, veritatis sit qui. Velit corrupti magnam repellat.'
  },
  {
    avatar: Me3,
    name: 'Jasu Imbrahim',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam consequatur veniam sed sunt, veritatis sit qui. Velit corrupti magnam repellat.'
  },
  {
    avatar: Me4,
    name: 'Rayan Khan',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam consequatur veniam sed sunt, veritatis sit qui. Velit corrupti magnam repellat.'
  },
]
const testimonial = () => {
  return (
    <section id="testimonial">
      <h5>Review from Clients</h5>
      <h2>Testimonials</h2>
      <Swiper className="container test_container"
      modules={[ Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      >
        {
          data.map(({avatar,name,review},index) => {
            return (
              <SwiperSlide key={index} className='test'>
          <div className="client_avatar">
            <img src={avatar} alt="" />
          </div>
          <h5>{name}</h5>
            <small className="client_review">{review}</small>
        </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default testimonial